// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"zTei4Sf0LX5biIqM2MjjP","row":"_22W1A3Kw7hEsbnoF8m4Iyn","content":"KHTp6jbcxQlexbSbJSCvz"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Content/styles.scss
 ** module id = 463
 ** module chunks = 0
 **/